<div class="dlg-shell" (contextmenu)="preventDefaultContextMenu($event)">

  <!-- ── Header ──────────────────────────────────────────────────────────── -->
  <div class="dlg-header">

    <div class="dlg-title">
      <span class="material-icons dlg-title-icon">description</span>
      <span class="dlg-filename" [title]="data.fileName">{{ data.fileName }}</span>
    </div>

    <div class="dlg-toolbar">

      <!-- Search -->
      <div class="search-box" *ngIf="headers.length > 0">
        <span class="material-icons search-icon">search</span>
        <input
          type="text"
          class="search-input"
          placeholder="Search in data…"
          [(ngModel)]="searchText"
          (input)="onSearch()"
          autocomplete="off"
        />
        <button class="clear-btn" *ngIf="searchText" (click)="clearSearch()" title="Clear">
          <span class="material-icons">close</span>
        </button>
      </div>

      <!-- Row count badge -->
      <span class="row-badge" *ngIf="headers.length > 0">
        {{ fromRow }}–{{ toRow }}
        <span class="row-badge-sep">/</span>
        {{ filteredRows.length }}
        <span *ngIf="searchText" class="row-badge-note"> of {{ allRows.length }}</span>
      </span>

      <!-- Close -->
      <button class="dlg-close-btn" (click)="close()" title="Close">
        <span class="material-icons">close</span>
      </button>
    </div>

  </div>

  <!-- ── Body ────────────────────────────────────────────────────────────── -->
  <div class="dlg-body">

    <!-- Error -->
    <div class="state-msg" *ngIf="error">
      <span class="material-icons state-icon error-icon">error_outline</span>
      {{ error }}
    </div>

    <!-- Empty file -->
    <div class="state-msg" *ngIf="!error && headers.length === 0">
      <span class="material-icons state-icon">inbox</span>
      No data found in this file.
    </div>

    <!-- No search results -->
    <div class="state-msg" *ngIf="!error && headers.length > 0 && filteredRows.length === 0">
      <span class="material-icons state-icon">search_off</span>
      No rows match <strong>"{{ searchText }}"</strong>
    </div>

    <!-- CSV table -->
    <div class="table-scroll" *ngIf="!error && pagedRows.length > 0" style="position: relative;">

      <table class="csv-table">
        <thead>
          <tr>
            <th class="rn-col">#</th>
            <th
              *ngFor="let h of headers; let i = index"
              class="col-header"
              [class.col-sorted]="sortColIndex === i"
              (click)="sortBy(i)"
              [matTooltip]="'Sort by ' + toTitleCase(h)"
            >
              <span class="col-header-label">{{ toTitleCase(h) }}</span>
              <span class="sort-icon" *ngIf="sortColIndex === i">
                <span class="material-icons">{{ sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span>
              </span>
              <span class="sort-icon sort-idle" *ngIf="sortColIndex !== i">
                <span class="material-icons">unfold_more</span>
              </span>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of pagedRows; let ri = index">
            <td class="rn-col">{{ fromRow + ri }}</td>
            <td
              *ngFor="let cell of row"
              class="data-cell"
              [class.cell-match]="cellMatches(cell)"
              [title]="cell"
              (contextmenu)="onCellContextMenu($event, cell)"
            >{{ cell }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Right-click context menu -->
      <div
        class="custom-context-menu"
        *ngIf="contextMenuVisible"
        [ngStyle]="{ 'top.px': contextMenuPosition.y, 'left.px': contextMenuPosition.x }"
        (click)="$event.stopPropagation()"
      >
        <ul>
          <li (click)="handleCopy()">Copy Value</li>
        </ul>
      </div>

    </div>

  </div>

  <!-- ── Footer / pagination ─────────────────────────────────────────────── -->
  <div class="dlg-footer">

    <div class="footer-left">
      <span class="total-rows" *ngIf="!error && allRows.length > 0">
        {{ allRows.length }} total row{{ allRows.length !== 1 ? 's' : '' }}
        <span *ngIf="searchText && filteredRows.length !== allRows.length">
          &nbsp;·&nbsp; {{ filteredRows.length }} matching
        </span>
      </span>
      <span class="hint" *ngIf="!error && headers.length > 0">
        &nbsp;·&nbsp; Right-click any cell to copy its value
      </span>
    </div>

    <div class="footer-center" *ngIf="showPagination">
      <button class="pg-btn" [disabled]="currentPage === 0" (click)="prevPage()">
        <span class="material-icons">chevron_left</span>
      </button>
      <span class="pg-label">Page {{ currentPage + 1 }} / {{ totalPages }}</span>
      <button class="pg-btn" [disabled]="currentPage >= totalPages - 1" (click)="nextPage()">
        <span class="material-icons">chevron_right</span>
      </button>
    </div>

    <div class="button-container">
      

      <button mat-stroked-button mat-dialog-close style="color: #3A6570" type="button" class="btn-cancel" (click)="close()">
        Close
      </button>
    </div>

  </div>

</div>
